export default __webpack_public_path__ + "static/Benefits-a37ec67aa257441dcd5c2b2c15664758.png";